export default __webpack_public_path__ + "static/media/universal.fd6fea16.png";